module.exports = __webpack_public_path__ + "img/introduction.8f3387bc.png";